import { FileCategory } from "../objects/fileCategory";
import { FileCategoryListCriteria } from "../objects/fileCategoryList";

export const EMPTY_FILE_CATEGORY: FileCategory = {
    name: '',
    icon: null
};

export const EMPTY_FILE_CATEGORY_LIST_CRITERIA: FileCategoryListCriteria = {
    search: '',
    page: 0,
    limit: 50
}